/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. ATGGCCATTGTAATG`)
};

const es_translate_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ej. ATGGCCATTGTAATG`)
};

const de_translate_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. ATGGCCATTGTAATG`)
};

const nl_translate_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. ATGGCCATTGTAATG`)
};

const fr_translate_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. ATGGCCATTGTAATG`)
};

const it_translate_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. ATGGCCATTGTAATG`)
};

const pt_br2_translate_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex.: ATGGCCATTGTAATG`)
};

const pt_translate_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por ex. ATGGCCATTGTAATG`)
};

const ja_translate_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: ATGGCCATTGTAATG`)
};

const zh_translate_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 ATGGCCATTGTAATG`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_input_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_input_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_input_placeholder", locale)
	if (locale === "en") return en_translate_input_placeholder(inputs)
	if (locale === "es") return es_translate_input_placeholder(inputs)
	if (locale === "de") return de_translate_input_placeholder(inputs)
	if (locale === "nl") return nl_translate_input_placeholder(inputs)
	if (locale === "fr") return fr_translate_input_placeholder(inputs)
	if (locale === "it") return it_translate_input_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_translate_input_placeholder(inputs)
	if (locale === "pt") return pt_translate_input_placeholder(inputs)
	if (locale === "ja") return ja_translate_input_placeholder(inputs)
	return zh_translate_input_placeholder(inputs)
};